import React, { useState } from "react"
import { getCareersJobUrl } from "../employme/careersRoutes"

export const getJobShareUrl = (jobId) => {
  if (!jobId) return ""
  const path = getCareersJobUrl(jobId)
  if (typeof window === "undefined") return path
  return `${window.location.origin}${path}`
}

const JobShareButton = ({ jobId, className = "", label = "Share" }) => {
  const [copied, setCopied] = useState(false)

  const handleShare = async (event) => {
    event.preventDefault()
    event.stopPropagation()

    const url = getJobShareUrl(jobId)
    if (!url) return

    try {
      if (navigator.share) {
        await navigator.share({ url, title: "Job opportunity" })
        return
      }
    } catch (err) {
      if (err?.name === "AbortError") return
    }

    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      window.prompt("Copy this job link:", url)
    }
  }

  return (
    <button
      type="button"
      onClick={handleShare}
      className={
        className ||
        "inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
      }
      aria-label="Share job link"
    >
      <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
        />
      </svg>
      {copied ? "Link copied!" : label}
    </button>
  )
}

export default JobShareButton
